import { useSubscription } from "@apollo/client";
import { NOTIFICATION_NUMBER_SUBSCRIPTION } from "@/modules/common/features/notifications/api";

export function useNotificationNumberSubscription() {
  const { data } = useSubscription(NOTIFICATION_NUMBER_SUBSCRIPTION);

  return {
    unreadMessageNumber: data?.personNotificationCountSubscription ?? 0,
  };
}
